import createIcon from "./createIcon";

const EditIcon = createIcon(
  "M12.5 8.33349L4.16663 16.6668V20.8335H20.8333M4.16663 20.8335L8.33329 20.8335L16.6666 12.5001M12.5 8.33349L15.4881 5.34531L15.4899 5.34354C15.9012 4.93221 16.1073 4.72617 16.3448 4.64901C16.554 4.58103 16.7794 4.58103 16.9886 4.64901C17.2259 4.72612 17.4317 4.93192 17.8425 5.34267L19.6548 7.15496C20.0673 7.56747 20.2736 7.77383 20.3509 8.01167C20.4189 8.22088 20.4189 8.44624 20.3509 8.65545C20.2737 8.89313 20.0676 9.09917 19.6557 9.5111L19.6548 9.51198L16.6666 12.5001M12.5 8.33349L16.6666 12.5001",
  "#3A9AD5",
  "2",
  "0 0 25 25"
);

export default EditIcon;
